jQuery(function($){  
  
  $(".promo-lists").slick({
      arrows: false,
      dots: false,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 1800,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },        
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  // Custom carousel nav
	$('.carousel-prev').click(function(){ 
		$(this).parent().find('.promo-lists').slick('slickPrev');
	} );
	
	$('.carousel-next').click(function(e){
		e.preventDefault(); 
		$(this).parent().find('.promo-lists').slick('slickNext');
	} );
  
});